import { listFontStacks, resolve } from "@lifecare-welfare/document-fonts";
import baseUrl from "flow/wrappers/baseUrl";

export default {
    listFontStacks,
    resolve,
    fontImportCssPath: `${baseUrl}dist/styles/fonts.css`,
    variablesCssPath: `${baseUrl}dist/styles/css_variables.css`
};
